import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { addData, getList } from '../../helpers/fackBackend_Helper';
import { getUserByRoleIdFailed, getUserByRoleIdSuccess, searchManualActivationDataFailed, searchManualActivationDataSuccess } from './actions';
import { GET_USER_BY_ROLE_ID, SEARCH_MANUAL_ACTIVATION } from './actionTypes';

function* getSearchManualActivation({ payload: searchData }) {
    try {
        const response = yield call(addData, '/getManualActivationReport', searchData);
        if (response.Status) {
            yield put(searchManualActivationDataSuccess(response.activationdata));
        }
        else {
            yield put(searchManualActivationDataFailed(response.message));
        }
    } catch (error) {
        yield put(searchManualActivationDataFailed(error));
    }
}

export function* watchGetSearchManualActivation() {
    yield takeEvery(SEARCH_MANUAL_ACTIVATION, getSearchManualActivation)
}

function* manualActivationReportSaga() {
    yield all([
        fork(watchGetSearchManualActivation)
    ]);
}
export default manualActivationReportSaga;

